<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{ config.i18n.wia_seo_l1_issue }}</h2>
      <div class="wia-categories">
        <p class="wia-category" v-for="issue in issueOptions" v-bind:key="issue.id">
          <strong>{{ issue.check }}</strong> <br/> <span>{{ issue.verify }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'WIA-SeoResultIssue',
  title: 'WIA All results',
  description: '',
  data () {
    return {
      categorySelected: '',
      l1Selected: '',
      l2Selected: '',
      l3Selected: '',
      error: '',
      issueOptions: [
      ]
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    config: function () {
      return this.$store.state.config
    },
    detail: function () {
      return this.$store.state.details
    }
  },
  methods: {
    getQueryStringValue (key) {
      // eslint-disable-next-line
      return decodeURIComponent(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
    },
    getBrand () {
      switch (this.$store.state.config.brand) {
        case 'WP':
          return '/021/'
        case 'ID':
          return '/IND/'
        case 'HP':
          return '/HOT/'
        case 'BK':
          return '/011/'
      }
    }
  },
  mounted () {
    this.categorySelected = this.getQueryStringValue('cat')
    this.l1Selected = this.getQueryStringValue('l1')
    this.l2Selected = this.getQueryStringValue('l2')
    this.l3Selected = this.getQueryStringValue('l3')

    // /check_and_resolve/{language}/{problem}/{brand}/{country}
    this.$http.get(this.$store.state.config.endpoint + '/check_and_resolve/' + this.$store.state.config.language.toLowerCase() + '/' + this.l3Selected + this.getBrand() + this.$store.state.config.country).then(
      result => {
        this.issueOptions = result.body
      }, error => {
        this.error = error.body
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../style/main';

.brand-theme-id {
}

.wia-categories {
  max-width: 68rem;
  margin: 0 auto;
}

.wia-category {
  display: block;
  width: 100%;
  margin-bottom: 15px;
  strong{
    margin-bottom: 5px;
  }
}

.brand-theme-hp {
}

.brand-theme-bk {
}

.brand-theme-wp {
}

.brand-theme-mb {
}

</style>
